module.exports = __webpack_public_path__ + "media/images/lp_v6_img09-edcda912659000b6a3366d353ce08002.webp";